import {
  FETCH_REPARACIONES_REQUEST,
  FETCH_REPARACIONES_SUCCESS,
  FETCH_REPARACIONES_FAILURE,
} from "../actions/reparaciones/types";

const initialState = { items: [], loading: false, error: null };

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REPARACIONES_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_REPARACIONES_SUCCESS:
      return { ...state, loading: false, items: Array.isArray(action.payload) ? action.payload : [], error: null };
    case FETCH_REPARACIONES_FAILURE:
      return { ...state, loading: false, error: action.payload?.error ?? "Error desconocido" };
    default:
      return state;
  }
};

export default reducer;
